<template>
    <div class="mt10">
        <div class="inline-block" style="vertical-align: top" v-show="status === 6" >
            <el-input class="shortest mr10"
                      v-model="price"
                      type="number"
                      size=""
                      placeholder="보상금을 입력하세요."
                      maxLength="30"
            ></el-input>
            <el-button class="com_btn" @click="changePrice()">보상금 입력</el-button>

        </div>
        <div class="filter-show-count" style="vertical-align: top">
            <el-select class="short mr10" v-model="updateStatus" @change="setData('updateStatus', updateStatus)">
                <el-option v-for="(data, value, index) in detectionStatus" :key="`status${value}`"
                           :label="data.name" :value="Number(value)"
                           :disabled="returnDisable(value) "></el-option>
            </el-select>
            <el-button class="com_del" @click="changeStatus()">상태 변경</el-button>
        </div>

    </div>
</template>

<script>
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import {detectionStatus} from "@/service/itemService";

export default {
    name: "ItemDetectionStatusComponent",
    mixins: [alertMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        detectionKey: '',
        status: '',
        beforePrice: {default: ''},
    },
    data() {
        return {
            detectionStatus: detectionStatus,
            updateStatus: '',
            price:'',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        console.log(this.status)
        this.updateStatus = this.status
        this.price = this.beforePrice;
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value
        },
        returnDetectStatus(value) {
            let keys = Object.keys(detectionStatus)
            let key = keys.filter(status => Number(status) === value);
            if (util.isEmpty(key)) {
                return '-'
            }
            console.log(detectionStatus[key])
            return detectionStatus[key]
        },
        changeStatus() {
            if(this.updateStatus === this.status + 1 ){
                let params = {
                    l_idx: this.detectionKey,
                    l_status: this.updateStatus
                }
                this.$api.$item.updateDetectionStatus(params).then(res => res.Data.Result).then(res =>{
                    if(res.Info.type === 1){
                        this.createAlert({content : '저장되었습니다.'})
                        EventBus.$emit('itemWriteGetItem')
                        this.$forceUpdate()
                    }else {
                        this.errorAlert('변경에 실패하였습니다.')
                    }
                })
            }else {
                this.errorAlert('변경에 실패하였습니다.')
            }
        },
        changePrice(){
            if(this.status === 6 && !util.isEmpty(this.price)){
                let params = {
                    l_idx: this.detectionKey,
                    l_price: this.price
                }
                this.$api.$item.updateDetectionPrice(params).then(res => res.Data.Result).then(res =>{
                    if(res.Info.type === 1){
                        this.createAlert({content : '보상금이 지급되었습니다.'})
                        EventBus.$emit('itemWriteGetItem')
                        this.$forceUpdate()
                    }else {
                        this.errorAlert('지급에 실패하였습니다.')

                    }
                })
            }else {
                this.errorAlert('지급에 실패하였습니다.')
            }
        },
        returnDisable(value){
            let status = this.status
            if(status === 6){
                return true
            }
            return  Number(value) !== 0 && (Number(value) <= status || Number(value) > status +1)
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
